import React, { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { TablePagination } from "@mui/material";

export const RecentApiCallTable = ({
  data = [],
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange
}) => {
  return (
    <Box>
      <Paper sx={{ width: "100%", borderRadius: 3, boxShadow: 2, p: 2 }}>
         <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
        </Box>
        <TableContainer>
          <Table>
          <TableHead>
            <TableRow
              sx={{
                height: 48,
                "& th": {
                  borderBottom: "1px solid #E5E7EB",
                  position: "relative",
                },
              }}
            >
              {[
                "Type",
                "Description",
                "Timestamp",
                "Status",
                "Details",
              ].map((head, index, arr) => (
                <TableCell
                  key={head}
                  align="center"
                  sx={{
                    fontSize: "13.5px",
                    fontWeight: 700,
                    color: "#111827",
                    paddingY: "10px", 
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "20px",
                      width: "1px",
                      backgroundColor: "#E5E7EB",
                      display: index === arr.length - 1 ? "none" : "block",
                    },
                  }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}
                sx={{
                  "& td": {
                    borderBottom: "1px solid #E5E7EB",
                  },
                }}>

                  <TableCell align="center" sx={{ fontSize: "13.5px"  }}>
                    {row.type}
                  </TableCell>

                  <TableCell align="center" sx={{ fontSize: "13.5px"  }}>
                    {row.description}
                  </TableCell>

                  <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                    {row.timestamp}
                  </TableCell>

                  <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                    {row.status}
                  </TableCell>

                  <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                    {row.metadata}
                  </TableCell>

                </TableRow>
              ))}

              {data.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ fontSize: "15px", fontWeight: 600 }}>
                    No Recent Activities found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={totalCount}
          page={page - 1} 
          onPageChange={(e, newPage) => onPageChange(newPage + 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            onPageChange(1); 
            onRowsPerPageChange(Number(e.target.value));
          }}
          rowsPerPageOptions={[8, 15, 25, 50]}
          sx={{
            mt: 2,
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              fontSize: "12px",
              fontWeight: 600,
            },
            "& .MuiTablePagination-select": {
              fontSize: "12px",
            },
          }}
        />
      </Paper>
    </Box>
  );
};
